import { isInterface } from "src/functions/general/checks";


export function filterDocgroupTypes(docgrouptypes?:DocgroupTypes[], doctypes?:DoctypeObject[], right:keyof DoctypeRights='view') {
    if(!Array.isArray(docgrouptypes) || !Array.isArray(doctypes)) return;

    let tmp = [...docgrouptypes]

    tmp = tmp.filter(dgt=>{
        const viewRight = doctypes.find(i=>i.doctype === dgt.doctype)?.rights.some(i=>i[right] === 1) ? true : false
        return viewRight
    })


    return tmp;
}

export function filterDoctypesArrayByRights(doctypeInput?:DoctypeObject[]) {
    if(!Array.isArray(doctypeInput)) return;
    let tmp = [...doctypeInput]

    tmp = tmp.filter(dt=>{
        const viewRight = dt.rights.some(r=>r.view===1) ? true : false;
        return viewRight
    })

    return tmp
}

export function hasDoctypeRight(doctype?:string, doctypes?:DoctypeObject[], right?:keyof DoctypeRights){
    if(!right) return false;
    return doctypes?.find(i=>i.doctype===doctype)?.rights.some(r=>r[right] === 1)
}

export function filterArrayByValue(arr: object[], searchValue: string, keysToFilterOn?: string[]) {
    return arr.filter(obj => checkNested(obj, searchValue, keysToFilterOn));
}

function checkNested(obj: Record<string, any>, searchValue: string, keysToFilterOn?: string[]): boolean {
    for (let key in obj) {
        if (obj.hasOwnProperty(key)) {
            if (keysToFilterOn && keysToFilterOn.length > 0 && !keysToFilterOn.includes(key)) {
                continue; // Skip this key if filtering on specific keys and it's not in the list
            }
            if (typeof obj[key] === "object" && obj[key] !== null) {
                if (checkNested(obj[key], searchValue, keysToFilterOn)) {
                    return true;
                }
            } else if (typeof obj[key] === 'string' && obj[key].toString().toLowerCase().includes(searchValue.toLowerCase()) || typeof obj[key] === 'number' && obj[key].toString().toLowerCase().includes(searchValue.toLowerCase())) {
                return true;
            }
        }
    }
    return false;
}